import React, { Component } from "react";
import ReactModal from "react-modal";
import { string, shape, node, bool, func, oneOf } from "prop-types";
import classNames from "classnames";
import ModalHeader from "./ModalHeader";
import ModalUntitledHeader from "./ModalUntitledHeader";
import _get from "lodash/get";

import ThemeConsumer from "../ThemeConsumer";

ReactModal.setAppElement("#main");

function getParent() {
  return document.querySelector("#main");
}

class Modal extends Component {
  static afterOpenModal() {
    document.body.classList.add("noOverflow");
    document.body.classList.remove("autoOverflow");
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isOpen) {
      document.body.classList.remove("noOverflow");
      document.body.classList.add("autoOverflow");
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("noOverflow");
    document.body.classList.add("autoOverflow");
  }

  closeModal(onClose) {
    document.body.classList.remove("noOverflow");
    document.body.classList.add("autoOverflow");
    onClose();
  }

  renderHeader() {
    const { onClose, icon, title, customTheme } = this.props;

    return title ? (
      <ModalHeader
        icon={icon}
        title={title}
        onClose={onClose}
        customTheme={customTheme}
      />
    ) : (
      <ModalUntitledHeader onClose={onClose} />
    );
  }

  render() {
    const {
      theme,
      isOpen,
      onClose,
      children,
      size,
      noOverflow,
      customTheme,
      vh100,
      classesModal,
      classesBodyModal,
      classesOverlay,
      isModalDisabled,
    } = this.props;

    const classes = classNames(classesModal, theme.modal, {
      [theme[size]]: !!size,
      [theme.vh100]: vh100,
    });

    const bodyClasses = classNames(
      noOverflow ? theme.noOverflowBodyModal : theme.bodyModal,
      classesBodyModal
    );

    const overlayClasses = classNames(theme.overlay, classesOverlay);

    if (isModalDisabled) {
      return null;
    }

    return (
      <ReactModal
        isOpen={isOpen}
        onRequestClose={() => this.closeModal(onClose)}
        onAfterOpen={Modal.afterOpenModal}
        className={classes}
        overlayClassName={overlayClasses}
        ariaHideApp={false}
        parentSelector={getParent}
      >
        <div className={theme.modalContainer}>
          {this.renderHeader()}

          <div className={bodyClasses}>
            <div
              className={
                theme[_get(customTheme, "bodyContainerModal")] ||
                theme.bodyContainerModal
              }
            >
              {children}
            </div>
          </div>
        </div>
      </ReactModal>
    );
  }
}

Modal.propTypes = {
  isOpen: bool,
  children: node,
  title: string,
  onClose: func,
  noOverflow: bool,
  size: oneOf(["auto", "acompanhamento", "large"]),
  icon: string,
  theme: shape({
    card: string,
    title: string,
    bodyContainerModal: string,
    titleText: string,
    isModalDisabled: bool
    // TODO: Especificar demais seletores do tema
  })
}


Modal.defaultProps = {
  children: null,
  onClose: null,
  isOpen: false,
  theme: {},
  icon: "",
  size: null,
  title: "",
  noOverflow: false,
  customTheme: {},
  isModalDisabled: false
}

export default ThemeConsumer("UIModal")(Modal);



// WEBPACK FOOTER //
// ./src/shared/components/Modal/index.js